export const getReviewDate = (value) => {
    const date = new Date(value);
    const now = new Date();

    const sameMonth = date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
    if (sameMonth) {
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric'
        });
    }

    const monthsAgo = (now.getFullYear() - date.getFullYear()) * 12 + (now.getMonth() - date.getMonth());

    return `${monthsAgo} month${monthsAgo > 1 ? 's' : ''} ago`;
};

// Sort date and return earliest date
export const getFormattedDate = (value) => {
    if (!Array.isArray(value) || value.length === 0) return null;
    const sortedDates = value.sort((a, b) => new Date(a) - new Date(b));
    const earliestDate = new Date(sortedDates[0]);
    return earliestDate.toISOString().split('T')[0];
};

//Converts an ISO date string (e.g., "2025-08-21T14:30:00Z") to a reversed date format "DD-MM-YYYY".
export const getFormattedDateReverse = (value) => {
    if (!value || value.length === 0) return null;
    if (value.length === 0) return null;
    return value.split('T')[0].split('-').reverse().join('-');
};

// Checks if the trip start date is more than No of days from today
export const isTripDateMoreThanNumOfDays = (startDate, noOfDays) => {
    const todaysDate = new Date();
    const tripStartDate = new Date(startDate);

    const normalizeDate = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const currentDate = normalizeDate(todaysDate);
    const tripDate = normalizeDate(tripStartDate);

    const differenceInDays = (tripDate - currentDate) / (1000 * 60 * 60 * 24);

    return differenceInDays > noOfDays;
};
